// extracted by mini-css-extract-plugin
export default {"headerSection":"Header_headerSection__elNf4","heading":"Header_heading__rPOVB","ctaTxt":"Header_ctaTxt__L0sfA","linkBox":"Header_linkBox__pq3MI","cover":"Header_cover__4mt+Q"};